import {
  addOutline,
  copyOutline,
  pencilOutline,
  printOutline,
  searchOutline,
  shareOutline,
  trashOutline,
} from 'ionicons/icons';

export const getIcon = (icon?: string) => {
  switch (icon) {
    case 'filter':
      return searchOutline;
    case 'insert':
      return addOutline;
    case 'edit':
      return pencilOutline;
    case 'copy':
      return copyOutline;
    case 'print':
      return printOutline;
    case 'delete':
      return trashOutline;
    case 'export':
      return shareOutline;
    default:
      // TODO: Implement rendering custom icon
      return null;
  }
};
